export default "__VITE_ASSET__IGbyWEZW__"